import { useState, useEffect } from 'react';
import { createSupplierInfo, fetchCountries } from '../../services/supplierService';

/**
 * Lightweight "Add New Supplier" modal that reuses the existing createSupplierInfo endpoint.
 * Designed to be rendered OVER another modal (higher z-index) without unmounting it.
 */
export default function AddNewSupplierModal({ onClose, onCreated }) {
  const [name, setName] = useState('');
  const [country, setCountry] = useState('');
  const [status, setStatus] = useState('Pending');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [countries, setCountries] = useState([]);

  useEffect(() => { fetchCountries().then(setCountries).catch(() => {}); }, []);

  const handleSave = async () => {
    if (!name.trim()) { setError('Supplier Name is required.'); return; }
    setSaving(true);
    setError(null);
    try {
      const result = await createSupplierInfo({
        supplier_name: name.trim(),
        supplier_approval_status: status,
        supplier_headquarter_country: country,
        contacts: [],
      });
      if (onCreated) onCreated({ supplier_id: result.supplier_id || result.id, supplier_name: name.trim() });
    } catch (err) {
      const data = err?.response?.data;
      if (data?.error === 'DUPLICATE') setError(data.message || 'A supplier with this name already exists.');
      else setError(data?.error || 'Failed to create supplier.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="sup-modal-backdrop" style={{ zIndex: 1070 }} onClick={onClose}>
      <div className="sup-modal" style={{ maxWidth: 460 }} onClick={(e) => e.stopPropagation()}>
        <div className="sup-modal-head">
          <h5 className="sup-modal-title mb-0">Add New Supplier</h5>
          <button type="button" className="sup-modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="sup-modal-body">
          <div className="upload-field">
            <label>Supplier Name <span style={{ color: '#dc2626' }}>*</span></label>
            <input
              className="upload-select"
              value={name}
              onChange={(e) => { setName(e.target.value); setError(null); }}
              placeholder="e.g. Adalvo Ltd"
              autoFocus
            />
          </div>
          <div className="upload-field">
            <label>HQ Country</label>
            <select className="upload-select" value={country} onChange={(e) => setCountry(e.target.value)}>
              <option value="">— Select —</option>
              {countries.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div className="upload-field">
            <label>Status</label>
            <select className="upload-select" value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="Pending">Pending</option>
              <option value="Approved">Approved</option>
              <option value="Suspended">Suspended</option>
            </select>
          </div>
          {error && <div style={{ fontSize: 12, color: '#dc2626', marginTop: 8 }}>{error}</div>}
        </div>
        <div className="sup-modal-foot">
          <button type="button" className="sup-btn" onClick={onClose} disabled={saving}>Cancel</button>
          <button type="button" className="sup-btn primary" onClick={handleSave} disabled={saving || !name.trim()}>
            {saving ? 'Creating...' : 'Create Supplier'}
          </button>
        </div>
      </div>
    </div>
  );
}
